import React, { useState } from "react";
import {
  SidebarContainer,
  SidebarMenu,
  SidebarLink,
  SidebarIcon,
  SidebarLogo,
} from "../Sidebar/SidebarElements";
import { FiHome, FiInfo, FiSettings, FiBriefcase, FiMail } from "react-icons/fi";
import logonav from "../../images/logonav.svg";
import ContactFormModal from "../Navbar/ContactFormModal";

const Sidebar = ({ isOpen, toggleMenu }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // This function prevents click event propagation to SidebarContainer
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggleMenu}>
      <SidebarLogo>
        <img src={logonav} alt="Logo" style={{ width: "120px", height: "auto" }} />
      </SidebarLogo>
      <SidebarMenu>
        <SidebarLink to="/inicio" activeStyle>
          <SidebarIcon>
            <FiHome />
          </SidebarIcon>
          Inicio
        </SidebarLink>
        <SidebarLink to="/sobre" activeStyle>
          <SidebarIcon>
            <FiInfo />
          </SidebarIcon>
          Sobre
        </SidebarLink>
        <SidebarLink to="/servicos" activeStyle>
          <SidebarIcon>
            <FiSettings />
          </SidebarIcon>
          Serviços
        </SidebarLink>
        <SidebarLink to="/portfolio" activeStyle>
          <SidebarIcon>
            <FiBriefcase />
          </SidebarIcon>
          Portfólio
        </SidebarLink>
        <SidebarLink to="/inicio" activeStyle onClick={openModal}>
          <SidebarIcon>
            <FiMail />
          </SidebarIcon>
          Fale conosco
        </SidebarLink>
        {/* Renderizar o modal dentro do Sidebar */}
        <ContactFormModal isOpen={isModalOpen} closeModal={closeModal} onClick={handleModalContentClick} />
      </SidebarMenu>
    </SidebarContainer>
  );
};

export default Sidebar;
